type NotFoundProps = {};

const NotFound = (props: NotFoundProps) => {
    return <div>404 Not found</div>;
};

export default NotFound;
